import request from '../request';

export type DictionaryWordsResponse = {
  list: string[];
  total: number;
};

export type DictionaryFields = {
  uuid: string;
  name: string;
  words: DictionaryWordsResponse;
};

export interface DictionaryCreateFields {
  uuid?: string;
  name: string;
  words: string[];
}

export interface DictionaryCreateParams {
  fields: DictionaryCreateFields;
}

export type DictionaryCreateResponse = {
  fields: DictionaryFields;
};

export interface DictionaryUpdateFields {
  name?: string;
  words?: {
    add?: string[];
    remove?: string[];
  };
}

export interface DictionaryUpdateParams {
  uuid: string;
  fields: DictionaryUpdateFields;
}

export type DictionaryUpdateResponse = {
  fields: DictionaryFields;
};

export interface DictionaryGetParams {
  uuid: string;
  wordsFilter?: {
    limit?: number;
    offset?: number;
    search?: string;
  };
}

export type DictionaryGetResponse = {
  fields: DictionaryFields;
};

export interface DictionaryDeleteParams {
  uuid: string;
}

export type DictionaryDeleteResponse = boolean;

export interface DictionaryGetListFilter {
  limit?: number;
  offset?: number;
}

export interface DictionaryGetListParams {
  filter?: DictionaryGetListFilter;
}

export type DictionaryGetListRow = {
  uuid: string;
  name: string;
};

export type DictionaryGetListResponse = {
  rows: DictionaryGetListRow[];
  total: number;
};

export const dictionaryCreate = request<
  DictionaryCreateResponse,
  DictionaryCreateParams
>({
  method: 'dictionary.create',
  pathPrefix: '/v2',
});

export const dictionaryUpdate = request<
  DictionaryUpdateResponse,
  DictionaryUpdateParams
>({
  method: 'dictionary.update',
  pathPrefix: '/v2',
});

export const dictionaryGet = request<
  DictionaryGetResponse,
  DictionaryGetParams
>({
  method: 'dictionary.get',
  pathPrefix: '/v2',
});

export const dictionaryDelete = request<
  DictionaryDeleteResponse,
  DictionaryDeleteParams
>({
  method: 'dictionary.delete',
  pathPrefix: '/v2',
});

export const dictionaryGetList = request<
  DictionaryGetListResponse,
  DictionaryGetListParams
>({
  method: 'dictionary.getList',
  pathPrefix: '/v2',
});
